import styled from 'styled-components';

export const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${({ $dark }) => ($dark ? 'rgba(5, 8, 13, 0.85)' : 'rgba(0, 0, 0, 0.5)')};
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
    padding: 20px;
    box-sizing: border-box;
`;

export const Modal = styled.div`
    background: ${({ $dark }) => ($dark ? '#1e293b' : '#fff')};
    border-radius: 12px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
    width: 100%;
    max-width: 400px;
    padding: 28px;
    font-family: 'Outfit', sans-serif;
    border: ${({ $dark }) => ($dark ? '1px solid rgba(71, 85, 105, 0.5)' : 'none')};
`;

export const Title = styled.h2`
    margin: 0 0 20px 0;
    font-size: 1.35rem;
    font-weight: 600;
    color: ${({ $dark }) => ($dark ? '#f8fafc' : '#1a2332')};
`;

export const Field = styled.div`
    margin-bottom: 18px;
    label {
        display: block;
        font-size: 0.9rem;
        font-weight: 500;
        color: ${({ $dark }) => ($dark ? '#94a3b8' : '#374553')};
        margin-bottom: 6px;
    }
    input {
        width: 100%;
        padding: 12px 14px;
        border: 2px solid ${({ $dark }) => ($dark ? 'rgba(71, 85, 105, 0.6)' : '#e8ecf0')};
        border-radius: 8px;
        font-size: 1rem;
        font-family: inherit;
        box-sizing: border-box;
        transition: border-color 0.2s;
        background: ${({ $dark }) => ($dark ? 'rgba(30, 41, 59, 0.8)' : '#fff')};
        color: ${({ $dark }) => ($dark ? '#e2e8f0' : 'inherit')};
        &::placeholder {
            color: ${({ $dark }) => ($dark ? '#64748b' : 'inherit')};
        }
        &:focus {
            outline: none;
            border-color: #64b5f6;
        }
    }
`;

export const PrimaryButton = styled.button`
    width: 100%;
    padding: 14px;
    background: ${({ $dark }) => ($dark ? 'linear-gradient(135deg, #2563eb, #1d4ed8)' : 'rgb(26, 148, 209)')};
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    transition: background 0.2s, transform 0.15s;
    &:hover:not(:disabled) {
        background: ${({ $dark }) => ($dark ? 'linear-gradient(135deg, #1d4ed8, #1e40af)' : 'rgb(22, 128, 180)')};
    }
    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

export const SecondaryButton = styled.button`
    width: 100%;
    padding: 12px;
    background: ${({ $dark }) => ($dark ? 'transparent' : 'transparent')};
    color: ${({ $dark }) => ($dark ? '#94a3b8' : '#6b7c8d')};
    border: 1px solid ${({ $dark }) => ($dark ? 'rgba(71, 85, 105, 0.6)' : '#e8ecf0')};
    border-radius: 8px;
    font-size: 0.95rem;
    font-family: inherit;
    cursor: pointer;
    margin-top: 10px;
    transition: background 0.2s, color 0.2s;
    &:hover {
        background: ${({ $dark }) => ($dark ? 'rgba(51, 65, 85, 0.6)' : '#f5f7f9')};
        color: ${({ $dark }) => ($dark ? '#e2e8f0' : '#1a2332')};
    }
`;

export const UserEmail = styled.p`
    margin: 0 0 20px 0;
    font-size: 0.95rem;
    color: ${({ $dark }) => ($dark ? '#94a3b8' : '#6b7c8d')};
    word-break: break-all;
`;

export const LinkButton = styled.a`
    display: block;
    width: 100%;
    padding: 14px;
    background: ${({ $dark }) => ($dark ? 'linear-gradient(135deg, #2563eb, #1d4ed8)' : 'rgb(26, 148, 209)')};
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 600;
    font-family: inherit;
    text-align: center;
    text-decoration: none;
    cursor: pointer;
    transition: background 0.2s;
    box-sizing: border-box;
    &:hover {
        background: ${({ $dark }) => ($dark ? 'linear-gradient(135deg, #1d4ed8, #1e40af)' : 'rgb(22, 128, 180)')};
    }
`;

export const ErrorText = styled.p`
    margin: 0 0 12px 0;
    font-size: 0.9rem;
    color: ${({ $dark }) => ($dark ? '#fca5a5' : '#c62828')};
`;

export const SuccessText = styled.p`
    margin: 0 0 12px 0;
    font-size: 0.9rem;
    color: ${({ $dark }) => ($dark ? '#86efac' : '#2e7d32')};
`;

export const TextLink = styled.button`
    background: none;
    border: none;
    padding: 0;
    font-size: 0.9rem;
    font-family: inherit;
    color: ${({ $dark }) => ($dark ? '#93c5fd' : 'rgb(26, 148, 209)')};
    cursor: pointer;
    text-decoration: underline;
    margin-top: 8px;
    &:hover {
        color: ${({ $dark }) => ($dark ? '#bfdbfe' : 'rgb(22, 128, 180)')};
    }
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 12px;
    right: 12px;
    width: 32px;
    height: 32px;
    border: none;
    background: ${({ $dark }) => ($dark ? 'rgba(51, 65, 85, 0.8)' : '#f5f7f9')};
    border-radius: 8px;
    font-size: 1.25rem;
    line-height: 1;
    cursor: pointer;
    color: ${({ $dark }) => ($dark ? '#94a3b8' : '#6b7c8d')};
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
        background: ${({ $dark }) => ($dark ? 'rgba(71, 85, 105, 0.8)' : '#e8ecf0')};
        color: ${({ $dark }) => ($dark ? '#e2e8f0' : '#1a2332')};
    }
`;

export const ModalInner = styled.div`
    position: relative;
`;

export const SubtitleText = styled.p`
    margin: 0 0 20px 0;
    font-size: 0.95rem;
    color: ${({ $dark }) => ($dark ? '#94a3b8' : '#6b7c8d')};
    line-height: 1.5;
`;
